// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject } from 'rxjs';

// HS Code
import { QuestionModel, QuestionTypes } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root',
})
export abstract class QuestionsBaseService {
  protected _questions$: BehaviorSubject<QuestionModel[] | null>;
  get questions$(): Observable<QuestionModel[] | null> {
    return this._questions$;
  }

  protected _indicatorQuestions$: BehaviorSubject<QuestionModel[] | null>;
  get indicatorQuestions$(): Observable<QuestionModel[] | null> {
    return this._indicatorQuestions$;
  }

  protected _effectivenessQuestions$: BehaviorSubject<QuestionModel[] | null>;
  get effectivenessQuestions$(): Observable<QuestionModel[] | null> {
    return this._effectivenessQuestions$;
  }

  protected _extraValueQuestions$: BehaviorSubject<QuestionModel[] | null>;
  get extraValueQuestions$(): Observable<QuestionModel[] | null> {
    return this._extraValueQuestions$;
  }

  protected _questionGroups$: BehaviorSubject<QuestionModel[][] | null>;
  get questionGroups$(): Observable<QuestionModel[][] | null> {
    return this._questionGroups$;
  }

  constructor() {
    this._questions$ = new BehaviorSubject<QuestionModel[] | null>(null);
    this._indicatorQuestions$ = new BehaviorSubject<QuestionModel[] | null>(
      null
    );
    this._effectivenessQuestions$ = new BehaviorSubject<QuestionModel[] | null>(
      null
    );
    this._extraValueQuestions$ = new BehaviorSubject<QuestionModel[] | null>(
      null
    );
    this._questionGroups$ = new BehaviorSubject<QuestionModel[][] | null>(null);
  }

  abstract loadQuestions(id: string, isParticipant?: boolean, force?: boolean): void;

  clearQuestions(): void {
    this._questions$.next(null);
  }

  protected initialiseQuestions(questions: QuestionModel[]): void {
    const indicatorQuestions = questions.filter((q) => {
      return q.questionType === QuestionTypes.indicator;
    });

    const effectivenessQuestions = questions.filter((q) => {
      return q.questionType === QuestionTypes.effectiveness;
    });

    const extraValueQuestions = questions.filter((q) => {
      return q.questionType === QuestionTypes.extraValue;
    });

    /// ToDo: Replace the magic number 15 with a constant
    const questionGroups = new Array<QuestionModel[]>();
    for (let i = 0; i < indicatorQuestions.length; i += 15) {
      questionGroups[i / 15 + 1] = indicatorQuestions.slice(i, i + 15);
    }

    this._questions$.next(questions);
    this._indicatorQuestions$.next(indicatorQuestions);
    this._effectivenessQuestions$.next(effectivenessQuestions);
    this._extraValueQuestions$.next(extraValueQuestions);
    this._questionGroups$.next(questionGroups);
  }
}
